import { environment } from "../../environments/environment";

export let SIGNALR_CONFIG = {
    HUBS: {
        NOTIFICATION: "notificationHub"
    },
    SERVEREVENTS: {
        PRICECHANGE: "priceChange",
        NEW_ACTIVITY: "newActivity",
        NEWNEGOCIO: "newNegocio",
        EDITED_NEGOCIO: "editedNegocio"
    },
    URLS: {
        API: environment.API_URL + "/api/signalr",
        HUBS: environment.API_URL + "/api/signalr/hubs"
    }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/signalr/signalR.utils.ts